import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';

import {
  ErrorMessage,
  Spinner,
} from '../../base';

import { Grid, Cell } from '../../base/styled';

import { TableCellUtils } from '../../widgets/widgetUtils';

import './ServiceComponentAnimation.scss';

const frames = (tmpc) => keyframes`
  0% {
    margin-top: 0;
  }
  25% {
    margin-top: 0;
  }
  75% {
    margin-top: -${tmpc}%;
  }
  100% {
    margin-top: -${tmpc}%;
  }
`;

const ScrollingDiv = styled.div`
  ${(props) => css`
    animation: ${frames(props.maxMarginTopPercent)} ${Math.floor(props.cycleDurationMilliseconds / 1000)}s linear;
  `}
`;

const StationaryDiv = styled.div`
  margin-top: 0;
`;

// TODO: Get rid of magic numbers, use sortColumnId to sort cells before display

class ServiceComponentAnimation extends Component {

  neverAnimated = true;

  state = { scrolling: false };

  componentDidUpdate(prevProps, _prevState) {
    if (prevProps.scrollerPaneVisible && !this.props.scrollerPaneVisible) {
      // Just disappeared...
      if (this.state.scrolling) {
        setTimeout(() => {
          this.setState({ scrolling: false });
        }, 0);
      }
    } else if (this.neverAnimated || (!prevProps.scrollerPaneVisible && this.props.scrollerPaneVisible)) {
      // Just appeared...
      this.neverAnimated = false;
      if (!this.state.scrolling) {
        setTimeout(() => {
          this.setState({ scrolling: true });
        });
      }
    }
  }

  render() {

    const {
      title = '',
      subtitle = '',
      sortColumnId,
      table = {},
    } = this.props;

    if (!table) {
      return React.createElement(Spinner);
    }

    const { data = null, error = null } = table;
    if (error) {
      return React.createElement(ErrorMessage, { error });
    }
    if (!data) {
      return React.createElement(Spinner);
    }

    const {
      columns = [],
      cells = [],
    } = data;

    const DivComponent = (this.state.scrolling ? ScrollingDiv : StationaryDiv);

    const sortedCells = [...cells];
    sortedCells.sort((cellA, cellB) => {
      const cA = cellA[sortColumnId];
      const cB = cellB[sortColumnId];
      const aValue = cA && typeof cA === 'string' ? cA.toUpperCase() : cA;
      const bValue = cB && typeof cB === 'string' ? cB.toUpperCase() : cB;
      if (aValue < bValue) {
        return -1;
      }
      if (aValue > bValue) {
        return 1;
      }
      return 0;
    });

    return (
      <div className="dashboard">
        <Grid
          columns={1}
          rows="50px 50px 1fr"
          alignContent="stretch"
          className="ServiceComponentAnimation"
        >
          <Cell>
            <div className="titles">
              <div>{title}</div>
              <div>{subtitle}</div>
            </div>
          </Cell>
          <Cell>
            <div className="entireWidth">
              {
                columns.map((column) => (
                  <div style={{ width: '20%' }} key={column.Header}>
                    {column.Header}
                  </div>
                ))
              }
            </div>
          </Cell>
          <Cell>
            <div style={{
              height: '100%',
              overflow: 'auto',
            }}
            >
              <DivComponent maxMarginTopPercent={this.props.maxMarginTopPercent} cycleDurationMilliseconds={this.props.cycleDurationMilliseconds}>
                {
                  sortedCells.map((cell) => (
                    <div className="entireWidth" key={cell.key}>
                      {
                        columns.map((column) => (
                          <div className="singleColumn" key={column.id}>
                            {
                              TableCellUtils.generateCellContent(cell[column.id], column, true)
                            }
                          </div>
                        ))
                      }
                    </div>
                  ))
                }
              </DivComponent>
            </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}

ServiceComponentAnimation.defaultProps = {
  title: '',
  subtitle: '',
  table: null,
  sortColumnId: 'name',
  maxMarginTopPercent: 100,
  cycleDurationMilliseconds: 0,
  scrollerPaneVisible: false,
};

ServiceComponentAnimation.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  table: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.object,
  }),
  sortColumnId: PropTypes.string,
  maxMarginTopPercent: PropTypes.number,
  cycleDurationMilliseconds: PropTypes.number,
  scrollerPaneVisible: PropTypes.bool,
};

export default ServiceComponentAnimation;
